import ProductCard from '@stitch-fix/mode-react/ProductCard';
import { formatMoney } from '@stitch-fix/format';
import { Look } from '../../../../../types/definitions/vendor/graphql-schema.d';
import { themeMapping } from '../../../../../utils/maps';
import { isOutOfStock } from '../../../../../utils/sortShopProductVariants';
import BookmarkButton from '../BookmarkButton/BookmarkButton';
export type Item = Look['shopProductVariants'][number];
type ShopTheLookProductCardProps = {
  item: Item;
  outfitId: string;
};
const ShopTheLookProductCard = ({
  item,
  outfitId
}: ShopTheLookProductCardProps) => {
  const priceCents = item.price.value;
  const fullPriceCents = item.priceMarkdown?.fullPrice?.value;
  const showFullPrice = typeof fullPriceCents === 'number' && fullPriceCents !== priceCents;
  const url = outfitId ? `${item.url}&outfit_id=${outfitId}` : item.url;
  const getStickerLabel = () => {
    if (isOutOfStock(item)) {
      return {
        variant: 'white' as const,
        text: 'Out of stock'
      };
    }
    if (item.stickerLabel?.label) {
      return {
        text: item.stickerLabel.label,
        variant: themeMapping[item.stickerLabel.theme]
      };
    }
    return undefined;
  };
  return <ProductCard href={url} size={item.size.name} brand={item.shopProduct.brand.name} name={item.shopProduct.name} colorName={item.color?.name ?? ''} sku={item.sku} price={formatMoney(priceCents, {
    inCents: true
  })} fullPrice={showFullPrice ? formatMoney(fullPriceCents, {
    inCents: true
  }) : undefined} heroAction={<BookmarkButton id={item.sku} isSaved={item.saved} />} stickerLabel={getStickerLabel()} heroMedia={{
    alt: item.image?.altText ?? '',
    baseUrl: item.image?.baseUrl ? `${item.image?.baseUrl}/c_pad,ar_4:5,b_white,f_auto,q_auto` : '',
    mediaPath: item.image?.mediaPath ?? '',
    sizes: {
      sm: 180
    }
  }} outOfStock={isOutOfStock(item)} />;
};
export default ShopTheLookProductCard;